import React from 'react';
import { Grid, Typography, Divider, Link, Box } from '@material-ui/core';

type linkType = {
  name: string;
  url: string;
};

interface PromotionsLinkProps {
  title: string;
  children?: JSX.Element | JSX.Element[];
  link: linkType;
  onClick?: () => void;
}

const PromotionsLink = ({ title, children, link, onClick = () => {} }: PromotionsLinkProps) => (
  <Grid item xs={12}>
    {children}
    <Box p={2}>
      <Typography variant="h6">{title}</Typography>
      <Link href={link.url} component="button" variant="body2" onClick={onClick}>
        {link.name}
      </Link>
    </Box>
    <Divider />
  </Grid>
);

interface ProductDetailsPromotionsProps {
  targets?: Array<string>;
  onClickGuarantees: () => void;
  onClickPolitics: () => void;
}
export const ProductDetailsPromotions = ({  onClickGuarantees, onClickPolitics }: ProductDetailsPromotionsProps) => (
  <Grid container xs={12}>
    <PromotionsLink
      title="Política de devoluciones"
      link={{
        name: 'Ver política de devoluciones',
        url: '/',
      }}
      onClick={onClickPolitics}
    />
    <PromotionsLink
      title="Garantía"
      link={{
        name: 'Más información sobre la garantía ',
        url: '/',
      }}
      onClick={onClickGuarantees}
    />
  </Grid>
);
